var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIAttentionRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 17.589 13.6L 10.2831 0.800005C 9.64837 -0.266668 8.16552 -0.266668 7.5302 0.800005L 0.224357 13.6C -0.410958 14.6667 0.38317 16 1.60082 16L 16.2126 16C 17.4302 16 18.2244 14.6667 17.589 13.6ZM 8.37725 5.33333C 8.37725 5.01332 8.58904 4.79999 8.90667 4.79999C 9.2243 4.79999 9.43609 5.01332 9.43609 5.33333L 9.43609 9.59999C 9.43609 9.91998 9.2243 10.1333 8.90667 10.1333C 8.58904 10.1333 8.37725 9.91998 8.37725 9.59999L 8.37725 5.33333ZM 7.84789 12.2667C 7.84789 12.8533 8.32433 13.3333 8.90673 13.3333C 9.48907 13.3333 9.96557 12.8533 9.96557 12.2667C 9.96557 11.68 9.48907 11.2 8.90673 11.2C 8.32433 11.2 7.84789 11.68 7.84789 12.2667Z",
    fill: "#E1E1E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAttentionRequired);
export default __webpack_public_path__ + "static/media/i_attention_required.f3ce14045d31844f54e08ce020c53f5e.svg";
export { ForwardRef as ReactComponent };